export default __webpack_public_path__ + "static/media/page-not-found-entrance.95477cfa.gif";